import { IStyle } from '@fluentui/react';
import { FontWeights, Sizes } from '@h2oai/ui-kit';

export interface IScheduleStyles {
  root?: IStyle;
  form?: IStyle;
  fields?: IStyle;
  cron?: IStyle;
  buttons?: IStyle;
  subTitle?: IStyle;
}

export interface IScheduleClassNames {
  root: string;
  form: string;
  fields: string;
  cron: string;
  buttons: string;
  subTitle: string;
}

export const scheduleStylesDefault: Partial<IScheduleStyles> = {
  root: {
    flex: 1,
    height: '100%',
    paddingTop: 17,
    minHeight: 0,
  },
  form: { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    overflow: 'auto',
  },
  cron: {
    display: 'flex',
    '>div:first-child': {
      width: '110px',
      lineHeight: '32px',
    },
    '>div:last-child': {
      flex: 1,
    },
  },
  subTitle: {
    fontWeight: FontWeights.semiBold,
    paddingTop: 6,
  },
  buttons: { display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: Sizes.padding },
};
